import { render, staticRenderFns } from "./ProjectSettingInfo.vue?vue&type=template&id=1bca71ac&scoped=true"
import script from "./ProjectSettingInfo.vue?vue&type=script&lang=js"
export * from "./ProjectSettingInfo.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettingInfo.vue?vue&type=style&index=0&id=1bca71ac&prod&scoped=true&lang=scss"
import style1 from "./ProjectSettingInfo.vue?vue&type=style&index=1&id=1bca71ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bca71ac",
  null
  
)

export default component.exports